import React, { useEffect, useRef, useContext } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { ContextBoard } from "../context/ContextBoard";

const PrivateRoute11 = ({ children, tokenKey = "tokenclassxi" }) => {
  const {
    setClass11JacStudent,
    setClass11Candidateid,
    setClass11Castecode,
    setClass11Divyangcode,
    setClass11Mode,
    setClass11OtherMode,
    setClass11otherstudent,
    setClass11exregulartudent,
    setClass11exregularmode,
    setClass11before2010mode,
    setClass11before2010,
  } = useContext(ContextBoard);

  const location = useLocation();
  const navigate = useNavigate();
  const token = sessionStorage.getItem(tokenKey);
  const prevPath = useRef(location.pathname + location.search);

  useEffect(() => {
    const currentPath = location.pathname;
    const currentSearch = new URLSearchParams(location.search);

    const prevURL = new URLSearchParams(prevPath.current.split("?")[1]);
    const prevPathname = prevPath.current.split("?")[0];

    /** Clear Class XI JAC flow state if navigating away */
    if (
      (prevPathname === "/class-xi-add-student-jac-page" ||
        prevPathname === "/class-xi-upload-document") &&
      !(
        currentPath === "/class-xi-add-student-jac-page" ||
        currentPath === "/class-xi-upload-document"
      )
    ) {
      setClass11OtherMode("");
      setClass11before2010mode("");
      setClass11exregularmode("");
      setClass11JacStudent("");
      setClass11Candidateid("");
      setClass11Castecode("");
      setClass11Divyangcode("");
      setClass11Mode("");
    }

    /** Clear Class XI Others flow state if navigating away */
    if (
      (prevPathname === "/class-xi-add-others-student" ||
        prevPathname === "/class-xi-upload-document") &&
      !(
        currentPath === "/class-xi-add-others-student" ||
        currentPath === "/class-xi-upload-document"
      )
    ) {
      setClass11Mode("");
      setClass11before2010mode("");
      setClass11exregularmode("");
      setClass11Candidateid("");
      setClass11Castecode("");
      setClass11Divyangcode("");
      setClass11OtherMode("");
      setClass11otherstudent("");
    }

    /** Clear Class XI Ex-Regular JAC flow state if navigating away */
    if (
      (prevPathname === "/class-xi-add-ex-regular-info-jac" ||
        prevPathname === "/class-xi-upload-document") &&
      !(
        currentPath === "/class-xi-add-ex-regular-info-jac" ||
        currentPath === "/class-xi-upload-document"
      )
    ) {
      setClass11Mode("");
      setClass11OtherMode("");
      setClass11before2010mode("");
      setClass11exregulartudent?.("");
      setClass11Candidateid("");
      setClass11Castecode("");
      setClass11Divyangcode("");
      setClass11exregularmode?.("");
    }

    /** Clear Class XI Before 2010 info if navigating away */
    if (
      (prevPathname === "/class-xi-board-registration" ||
        prevPathname === "/class-xi-upload-document") &&
      !(
        currentPath === "/class-xi-board-registration" ||
        currentPath === "/class-xi-upload-document"
      )
    ) {
      setClass11Mode("");
      setClass11OtherMode("");
      setClass11exregularmode("");
      setClass11before2010?.("");
      setClass11Candidateid("");
      setClass11Castecode("");
      setClass11Divyangcode("");
      setClass11before2010mode?.("");
    }

    /** ✅ Case 2: If navigating from upload-document to add pages → redirect to dashboard */
    if (
      prevPathname === "/class-xi-upload-document" &&
      (currentPath === "/class-xi-add-student-jac-page" ||
        currentPath === "/class-xi-add-others-student" ||
        currentPath === "/class-xi-add-ex-regular-info-jac" ||
        currentPath === "/class-xi-board-registration" ||
        currentPath === "/class-xi-correction-regular" ||
        currentPath === "/class-xi-correction-exregular" ||
        currentPath === "/class-xi-correction-others" ||
        currentPath === "/class-xi-correction-board-registration")
    ) {
      setClass11JacStudent("");
      setClass11Candidateid("");
      setClass11Castecode("");
      setClass11Divyangcode("");
      setClass11Mode("");
      setClass11OtherMode("");
      setClass11otherstudent("");
      setClass11exregulartudent?.("");
      setClass11exregularmode?.("");
      setClass11before2010?.("");
      setClass11before2010mode?.("");

      navigate("/class-xi-dashboard", { replace: true });
    }

    prevPath.current = location.pathname + location.search;
  }, [location, navigate]);

  if (token) {
    const currentPath = location.pathname;
    if (
      sessionStorage.getItem("class11profile") === "NO" &&
      currentPath !== "/class-xi-school-profile"
    ) {
      return <Navigate to="/class-xi-school-profile" />;
    }
  } else {
    return <Navigate to="/class-xi" replace />;
  }

  return children;
};

export default PrivateRoute11;
